// GoldZakatCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import GoldZakatTable from "./GoldZakatTable";
import { SERVER_URL } from "./ConstantsIslamicCalculator";
import { Gold_Zakat_EndPoint } from "./ConstantsIslamicCalculator";
import SharedHelmet from "../Helmet";
const TITLE = 'Kalkulator Zakat Emas 2026 - Kalkulator Nisab Zakat Emas';
const DESCRIPTION = "Gunakan Kalkulator Zakat Emas untuk menghitung jumlah zakat yang wajib dikeluarkan atas emas dengan akurasi tinggi, berdasarkan berat, karat, dan harga gram saat ini. Alat yang terpercaya dan sesuai dengan ketentuan syariah.";
const KEYWORDS = 'zakat emas, nisab zakat emas, perhitungan zakat, karat 21, karat 22, karat 24, zakat harta, kewajiban zakat';
const OG_URL = 'https://do-calculate.com/calculator/id/gold-zakat/';
const apiEndpoint = `${SERVER_URL}/${Gold_Zakat_EndPoint}`;
function GoldZakatCalculator() {
    const [yearType, setYearType] = useState('');
    const [gramPriceGold, setGramPriceGold] = useState(0);
    const [gramPriceSilver, setGramPriceSilver] = useState(0);
    const [result, setRestul] = useState(null);
    const [error, setError] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [goldWeights, setGoldWeights] = useState([0, 0, 0, 0, 0, 0]);
    const goldKarats = [24, 22, 21, 18, 14, 10];
    const handleWeightsChange = (index, weight) => {
        const updatedWeights = [...goldWeights];
        updatedWeights[index] = parseFloat(weight);
        setGoldWeights(updatedWeights);
    };
    const handleYearTypeChange = (event) => {
        setYearType(event.target.value);
    };
    const handleGramPriceGoldChange = (event) => {
        setGramPriceGold(event.target.value);
    };
    const handleGramPriceSilverChange = (event) => {
        setGramPriceSilver(event.target.value);
    };
    const calculateGoldZakat = async () => {
        const convertedGoldWeights = goldWeights.map((weight) => Number(weight));
        setIsLoading(true);
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ goldWeights: convertedGoldWeights, goldKarats, gramPriceGold, yearType }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setRestul(data.result);
                setError(null);
            } else {
                setRestul(null);
                setError(data.error);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div >
            <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px', }}>
                        <h1 style={{ fontSize: '15px' }}>  Hitung Zakat Emas untuk Berbagai Karat </h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                <p>
                                    Kalkulator Zakat Emas adalah alat canggih dan akurat yang dirancang khusus untuk memudahkan proses penghitungan jumlah zakat yang wajib dikeluarkan atas emas, sesuai sepenuhnya dengan ketentuan syariah Islam. Ikuti langkah-langkah sederhana berikut untuk menggunakan kalkulator:
                                </p>
                                <ul>
                                    <li>
                                        <strong>Masukkan berat emas:</strong> Tentukan total berat emas yang Anda miliki dalam gram.
                                    </li>
                                    <li>
                                        <strong>Pilih karat emas:</strong> Pilih dari berbagai karat seperti 21, 22, atau 24 karat untuk menentukan jenis emas.
                                    </li>
                                    <li>
                                        <strong>Masukkan harga per gram:</strong> Masukkan harga gram saat ini untuk karat yang Anda pilih.
                                    </li>
                                    <li>
                                        <strong>Hitung zakat:</strong> Tekan tombol "Hitung Zakat" untuk mengetahui jumlah yang wajib dibayarkan sebagai zakat.
                                    </li>
                                    <li>
                                        <strong>Periksa hasil:</strong> Periksa jumlah zakat yang wajib dibayarkan dan pastikan keakuratan data yang dimasukkan.
                                    </li>
                                </ul>
                                <p>
                                    Dengan alat ini, Anda dapat merasa tenang karena Anda sepenuhnya mematuhi ajaran Islam dan menunaikan kewajiban agama Anda terkait zakat emas, tanpa kerumitan atau usaha yang berat.
                                </p>
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-5 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    <h2 style={{ fontSize: '15px' }}>Kalkulator Zakat Emas</h2>
                                </div>
                                <hr />
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='yearType' >Jenis Tahun</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="yearType"
                                            value="gregorian"
                                            id="gregorian"
                                            checked={yearType === "gregorian"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="gregorian">
                                            Masehi
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="yearType"
                                            value="hijri"
                                            id='hijri'
                                            checked={yearType === "hijri"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="hijri">
                                            Hijriah
                                        </label>
                                    </div>
                                </div>
                                <br />
                                <div>
                                    {goldKarats.map((karat, index) => (
                                        <div key={index}>
                                            <div className="form-group d-flex align-items-center">
                                                <b>
                                                    <label htmlFor="amoutNumber" className="form-label ms-2">{`Berat emas karat ${karat}`}</label>
                                                </b>
                                                <input
                                                    type="number"
                                                    id="amoutNumber"
                                                    value={goldWeights[index]}
                                                    onChange={(e) => handleWeightsChange(index, e.target.value)}
                                                    className="form-control ml-2"
                                                    style={{ width: '150px' }}
                                                />
                                                <div className="input-group-append">
                                                    <span className="input-group-text">g</span>
                                                </div>
                                            </div>
                                            <br />
                                        </div>
                                    ))}
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='gramPriceGoldNumber' className="form-label ms-2">Harga gram emas (24 karat)</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="gramPriceGoldNumber"
                                        value={gramPriceGold}
                                        onChange={handleGramPriceGoldChange}
                                        className="form-control ml-2"
                                        style={{ width: '150px' }}
                                    />
                                </div>
                                <br/>                                <hr />
                                <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={
                                    calculateGoldZakat} disabled={isLoading}>
                                    {isLoading ? (
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    ) : (
                                        'Hitung'
                                    )}
                                </button>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u> Terjadi kesalahan :</u></b> Harap isi semua bidang dengan benar. </div>}
                                {result &&
                                    (
                                        <div>
                                            <h4><div className="p-3 mb-2 bg-success text-white">Hasil: </div></h4>
                                            <hr />
                                            <GoldZakatTable result={result}></GoldZakatTable>
                                        </div>
                                    )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <br />
                    <MainCalculatorsList />
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">
                                <h2 style={{ fontSize: "18px" }}>{TITLE}</h2>
                            </div>
                            <div className="info-section-body">
                                <p>{DESCRIPTION}</p>
                                <div>
                                    <h3 style={{ fontSize: '16px' }}>Cara Menghitung Zakat Emas</h3>
                                    <p>Untuk menghitung zakat emas, Anda perlu mengetahui beberapa faktor dasar seperti:</p>
                                    <ul>
                                        <li><strong>Berat emas:</strong> Total berat emas yang Anda miliki.</li>
                                        <li><strong>Karat emas:</strong> Tingkat kemurnian emas, seperti 21, 22, atau 24 karat.</li>
                                        <li><strong>Harga per gram:</strong> Harga saat ini per gram emas.</li>
                                        <li><strong>Kalender:</strong> Jenis tahun yang digunakan (Hijriah atau Masehi).</li>
                                    </ul>
                                    <p>Pertama, berat emas dikonversi ke berat aktual emas murni berdasarkan karatnya. Kemudian, jika berat bersih melebihi 85 gram, zakat emas dihitung menggunakan persentase zakat yang ditetapkan:</p>
                                    <ul>
                                        <li><strong>Persentase zakat dalam kalender Hijriah:</strong> 2.5%.</li>
                                        <li><strong>Persentase zakat dalam kalender Masehi:</strong> 2.577%.</li>
                                    </ul>
                                    <p>Untuk menghitung zakat emas, nilai yang dihitung dikalikan dengan persentase zakat dan harga gram saat ini untuk mendapatkan jumlah uang final yang wajib dikeluarkan.</p>
                                    <p>Kalkulator ini akan memberikan hasil dalam bentuk laporan yang mencakup:</p>
                                    <ul>
                                        <li>Total berat emas murni.</li>
                                        <li>Penentuan apakah zakat emas wajib dikeluarkan atau tidak.</li>
                                        <li>Jumlah uang yang wajib dibayarkan sebagai zakat.</li>
                                        <li>Jumlah zakat emas itu sendiri.</li>
                                        <li>Batas berat minimum yang mewajibkan zakat.</li>
                                    </ul>
                                </div>
                                <hr />
                                <div>
                                    <h3 style={{ fontSize: '16px' }}>Penerapan Kalkulator di Negara-negara Arab</h3>
                                    <p>Kalkulator ini adalah alat yang berguna untuk menghitung zakat emas di semua negara Arab, termasuk:</p>
                                    <ul>
                                        <li>Arab Saudi</li>
                                        <li>Uni Emirat Arab</li>
                                        <li>Mesir</li>
                                        <li>Yordania</li>
                                        <li>Lebanon</li>
                                        <li>Palestina</li>
                                        <li>Aljazair</li>
                                        <li>Maroko</li>
                                        <li>Tunisia</li>
                                        <li>Yaman</li>
                                        <li>Oman</li>
                                        <li>Kuwait</li>
                                        <li>Suriah</li>
                                        <li>Qatar</li>
                                        <li>Sudan</li>
                                    </ul>
                                    <p>Kalkulator ini dikembangkan untuk memenuhi kebutuhan individu di negara-negara ini sesuai dengan standar zakat yang diakui.</p>
                                    <p>Untuk informasi lebih lanjut tentang zakat emas, Anda dapat mengunjungi sumber-sumber berikut:</p>
                                    <ul>
                                        <li><a href="https://www.islamic-relief.me/%D8%AD%D8%B3%D8%A7%D8%A8-%D8%B2%D9%83%D8%A7%D8%A9-%D8%A7%D9%84%D9%85%D8%A7%D9%84/" rel="nofollow noreferrer" target="_blank">Islamic Relief Worldwide</a></li>
                                    </ul>
                                    <p><strong>Tanggal revisi terakhir:</strong> 28/02/2026</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default GoldZakatCalculator;